import React, { useState } from 'react';
import { FiUploadCloud, FiCpu, FiCheckCircle, FiTrash2 } from 'react-icons/fi'; // 👈 Adicionamos o FiTrash2
import toast from 'react-hot-toast';
import api from '../services/api';
import * as XLSX from 'xlsx';

export default function UploadInvoiceAI({ onDadosExtraidos }) {
  const [isLendo, setIsLendo] = useState(false);
  const [nomeArquivo, setNomeArquivo] = useState('');

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setNomeArquivo(file.name);
    setIsLendo(true);
    const toastId = toast.loading('IA do Gemini analisando o documento...');

    try {
      const formData = new FormData();

      if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls') || file.name.endsWith('.csv')) {
        const arrayBuffer = await file.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });
        
        const primeiraAba = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[primeiraAba];
        const textoCsv = XLSX.utils.sheet_to_csv(worksheet);
        
        const blobTexto = new Blob([textoCsv], { type: 'text/plain' });
        formData.append('file', blobTexto, 'invoice_convertida.txt');
      } else {
        formData.append('file', file);
      }

      const response = await api.post('/invoice/extrair', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const dadosIA = response.data; 
      toast.success('Dados extraídos com extrema precisão!', { id: toastId });
      
      onDadosExtraidos(dadosIA); 

    } catch (error) {
      toast.error('Erro ao ler o arquivo. Verifique se a planilha tem os dados corretos.', { id: toastId });
      console.error("Erro na IA:", error);
      setNomeArquivo('');
    } finally {
      setIsLendo(false);
      e.target.value = null; 
    }
  };

  // 👈 FUNÇÃO PARA LIMPAR O ARQUIVO
  const handleLimparArquivo = (e) => {
    e.preventDefault();
    setNomeArquivo(''); // Reseta o estado, fazendo a caixa de upload voltar
  };

  return (
    <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-6 rounded-2xl border border-indigo-100 mb-8 shadow-sm relative overflow-hidden">
      <div className="absolute -right-10 -top-10 w-32 h-32 bg-purple-200 rounded-full blur-3xl opacity-50"></div>

      <div className="flex items-start gap-4 relative z-10">
        <div className="p-3 bg-indigo-100 text-indigo-600 rounded-xl">
          <FiCpu size={24} className={isLendo ? "animate-pulse" : ""} />
        </div>
        
        <div className="flex-1">
          <h3 className="text-lg font-black text-indigo-900 mb-1 flex items-center gap-2">
            Automação Inteligente (OCR & Dados)
          </h3>
          <p className="text-sm text-indigo-700 mb-4 font-medium">
            Faça upload da sua Invoice (Excel, PDF ou Imagem). Nossa Inteligência Artificial preencherá o formulário automaticamente.
          </p>

          <div className="relative">
            {/* 👈 O INPUT INVISÍVEL SÓ EXISTE SE NÃO TIVER ARQUIVO LIDO */}
            {!nomeArquivo && (
                <input 
                type="file" 
                accept=".pdf, image/png, image/jpeg, image/jpg, .xlsx, .xls, .csv" 
                onChange={handleFileUpload}
                disabled={isLendo}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-not-allowed z-10"
                />
            )}

            {/* CAIXA VISUAL */}
            <div className={`flex items-center w-full px-6 py-3 rounded-xl border-2 transition-all relative
              ${isLendo ? 'border-indigo-300 bg-indigo-50 text-indigo-400 border-dashed justify-center' : 
                nomeArquivo ? 'border-emerald-300 bg-emerald-50/50 border-solid justify-between' : // 👈 Sucesso: Borda sólida e justify-between
                'border-indigo-300 bg-white text-indigo-600 hover:bg-indigo-50 hover:border-indigo-400 border-dashed justify-center'}
            `}>
              
              {isLendo ? (
                <>
                  <div className="w-5 h-5 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin mr-2"></div>
                  <span className="font-bold">Processando dados...</span>
                </>
              ) : nomeArquivo ? (
                <>
                  {/* LADO ESQUERDO: Nome do arquivo com check */}
                  <div className="flex items-center gap-2 truncate pr-4">
                    <FiCheckCircle size={20} className="text-emerald-500 flex-shrink-0" />
                    <span className="font-bold text-emerald-700 truncate">{nomeArquivo} lido</span>
                  </div>
                  
                  {/* LADO DIREITO: Botão de Lixeira */}
                  <button 
                    type="button"
                    onClick={handleLimparArquivo}
                    className="p-2 text-emerald-600 hover:text-red-600 hover:bg-red-100 rounded-lg transition-colors cursor-pointer z-20"
                    title="Remover arquivo"
                  >
                    <FiTrash2 size={20} />
                  </button>
                </>
              ) : (
                <>
                  <FiUploadCloud size={20} className="mr-2" />
                  <span className="font-bold">Anexar Invoice (Excel/PDF)</span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}